import { takeLatest, call, put, select } from 'redux-saga/effects'
import fileDownload from 'js-file-download'
import actionTypes from '../../actions/actionTypes'
import createApiCall from '../../apis/wpApi/endpoints'

const FORMATS = {
    'ig-feed-4-5':   { width: 1080, height: 1350 },
    'ig-feed-1-1':   { width: 1080, height: 1080 },
    'ig-story-9-16': { width: 1080, height: 1920 },
    'fb-feed-1-91':  { width: 1200, height:  630 },
    'fb-story-9-16': { width: 1080, height: 1920 },
    'x-16-9':        { width: 1200, height:  675 },
    'linkedin-1-91': { width: 1200, height:  627 },
}

const baseUrlSelector = state => ({
    baseURL: state.getIn(['wpServerData', 'data', 'data', 'site', 'url_site'])
})

const renderSleepSelector = state => ({
    renderSleep: state.getIn(['wpServerData', 'data', 'data', 'features', 'rendersleep_setting']) || 0
})

function encodeImageState(imageState) {
    return btoa(encodeURIComponent(JSON.stringify(imageState)))
}

function* downloadSocialMedia(action) {
    try {
        const { images, formatId, customWidth, customHeight, presetId, cinemaId } = action.payload
        const { baseURL }    = yield select(baseUrlSelector)
        const { renderSleep }= yield select(renderSleepSelector)

        const fmt    = FORMATS[formatId] || null
        const width  = formatId === 'custom' ? customWidth  : (fmt ? fmt.width  : 1080)
        const height = formatId === 'custom' ? customHeight : (fmt ? fmt.height : 1350)

        const PRINT_API_BASE_URL = pmkinoClientVars.printHeadlessChromeServiceURL

        if (images.length === 1) {
            const imageState = Object.assign({}, images[0], { width, height })
            const encodedUrl = encodeURI(
                `${baseURL}/pmkinoprint/print/#/${cinemaId}/socialmedia/${presetId}/${encodeImageState(imageState)}`
            )

            const response = yield call(() => createApiCall({
                url:    PRINT_API_BASE_URL + 'page/image',
                method: 'POST',
                data: {
                    url:            encodedUrl,
                    format:         'png',
                    responseFormat: 'BASE64',
                    renderOptions: {
                        viewPortWidth:  width,
                        viewPortHeight: height,
                        renderSleep,
                    },
                },
            }))

            const binary = atob(response.data.replace(/\s/g, ''))
            const bytes  = new Uint8Array(binary.length)
            for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
            fileDownload(bytes, 'social-post.png', 'image/png')

        } else {
            const renderImages = images.map((image, i) => {
                const imageState = Object.assign({}, image, { width, height })
                const encodedUrl = encodeURI(
                    `${baseURL}/pmkinoprint/print/#/${cinemaId}/socialmedia/${presetId}/${encodeImageState(imageState)}`
                )
                return {
                    url:      encodedUrl,
                    filename: String(i + 1).padStart(2, '0'),
                    renderOptions: {
                        viewPortWidth:  width,
                        viewPortHeight: height,
                        renderSleep,
                    },
                }
            })

            const response = yield call(() => createApiCall({
                url:    PRINT_API_BASE_URL + 'page/images',
                method: 'POST',
                data: {
                    format:        'png',
                    archiveName:   'social-posts.zip',
                    responseFormat: 'BASE64',
                    images:        renderImages,
                },
            }))

            const binary = atob(response.data.replace(/\s/g, ''))
            const bytes  = new Uint8Array(binary.length)
            for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
            fileDownload(bytes, 'social-posts.zip', 'application/zip')
        }

        yield put({ type: actionTypes.SOCIAL_MEDIA_DOWNLOAD_SUCCESS })

    } catch (e) {
        console.error('Social media download failed', e)
        yield put({ type: actionTypes.SOCIAL_MEDIA_DOWNLOAD_ERROR, payload: e.message })
    }
}

function* watchSocialMediaDownload() {
    yield takeLatest(actionTypes.SOCIAL_MEDIA_DOWNLOAD_REQUEST, downloadSocialMedia)
}

export default watchSocialMediaDownload
